/**
 * Store entry point: the `store` singleton plus the `dialog` store and their types.
 *
 * ```ts
 * import { store, dialog } from '$lib/store';
 * await store.boot();
 * const name = await dialog.open({ kind: 'prompt', title: t('newFolder') });
 * ```
 */
import { MailStore } from './mail.svelte';

export { MailStore } from './mail.svelte';
export { MailState, applyTheme, readTheme, readRail, writeRail, LS } from './state.svelte';
export type { UndoSlot, NotifyPerm } from './state.svelte';
export { dialog, prompt, confirm, DialogStore, ToastModule, TOAST_MS, TOAST_UNDO_MS } from './ui.svelte';
export type { DialogSpec } from './ui.svelte';
export type { ActOptions } from './ops.svelte';
export type { SyncOptions } from './list.svelte';
export type { PushResult } from './push.svelte';

/** The one application store. Created at import time; call `store.boot()` once from `main.ts`. */
export const store = new MailStore();
